module.exports = __webpack_public_path__ + "static/media/6.d9d7fd10.jpeg";